var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.49 17.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.44,2.74A3.88,3.88,0,0,0,10.32,0,3.72,3.72,0,0,0,7.81,1.31a3.58,3.58,0,0,0-.9,2.63,3.13,3.13,0,0,0,2.53-1.2m.82,1.38c-1.4-.08-2.58.8-3.25.8s-1.69-.75-2.79-.73A4.12,4.12,0,0,0,.72,6.33c-1.5,2.6-.4,6.48,1.06,8.59.71,1,1.56,2.21,2.69,2.17s1.48-.7,2.77-.7,1.67.7,2.79.67,1.9-1,2.6-2.1a9.34,9.34,0,0,0,1.17-2.42,3.77,3.77,0,0,1-2.27-3.46,3.87,3.87,0,0,1,1.83-3.26,4,4,0,0,0-3.1-1.7m8.93-2V5h2.28V6.84H19.19V13.6c0,1,.45,1.52,1.45,1.52a5.76,5.76,0,0,0,.82-.06V17a7.67,7.67,0,0,1-1.35.1c-2.36,0-3.27-.91-3.27-3.21v-7H15.05V5h1.74V2.11ZM29.44,17h-2.5L22.74,5h2.49l2.95,9.61h.06l3-9.61h2.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.47,
    y: 5.03,
    width: 2.17,
    height: 11.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.47,
    y: 5.03,
    width: 2.17,
    height: 11.86,
    transform: "translate(28.6 50.51) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleTv);
export default __webpack_public_path__ + "static/media/appleTV.a90fe7c285248ce39f2d44c59284087a.svg";
export { ForwardRef as ReactComponent };